import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

export default function ContactForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = t("cta.form.required");
    if (!form.email.trim()) errs.email = t("cta.form.required");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errs.email = t("cta.form.invalid_email");
    if (!form.message.trim()) errs.message = t("cta.form.required");
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    navigate("/thank_you");
  };

  return (
    <form onSubmit={onSubmit} noValidate className="grid grid-cols-1 gap-5">
      <div>
        <label htmlFor="name" className="block zv-mono-tag mb-2 text-[#0d1117]/60">
          {t("cta.form.name")}
        </label>
        <input
          id="name"
          name="name"
          value={form.name}
          onChange={onChange}
          placeholder={t("cta.form.name_ph")}
          className="w-full bg-transparent border-b border-[#0d1117]/30 focus:border-[#c8622a] outline-none py-3 text-[18px] text-[#0d1117]"
          aria-invalid={!!errors.name}
        />
        {errors.name && <div className="text-[13px] text-[#a34e1e] mt-1">{errors.name}</div>}
      </div>
      <div>
        <label htmlFor="email" className="block zv-mono-tag mb-2 text-[#0d1117]/60">
          {t("cta.form.email")}
        </label>
        <input
          id="email"
          name="email"
          type="email"
          value={form.email}
          onChange={onChange}
          placeholder={t("cta.form.email_ph")}
          className="w-full bg-transparent border-b border-[#0d1117]/30 focus:border-[#c8622a] outline-none py-3 text-[18px] text-[#0d1117]"
          aria-invalid={!!errors.email}
        />
        {errors.email && <div className="text-[13px] text-[#a34e1e] mt-1">{errors.email}</div>}
      </div>
      <div>
        <label htmlFor="message" className="block zv-mono-tag mb-2 text-[#0d1117]/60">
          {t("cta.form.message")}
        </label>
        <textarea
          id="message"
          name="message"
          rows={4}
          value={form.message}
          onChange={onChange}
          placeholder={t("cta.form.message_ph")}
          className="w-full bg-transparent border-b border-[#0d1117]/30 focus:border-[#c8622a] outline-none py-3 text-[18px] text-[#0d1117] resize-none"
          aria-invalid={!!errors.message}
        />
        {errors.message && <div className="text-[13px] text-[#a34e1e] mt-1">{errors.message}</div>}
      </div>
      <div className="mt-2">
        <button type="submit" className="zv-btn zv-btn-primary">
          {t("cta.form.submit")}
          <ArrowRight size={16} />
        </button>
      </div>
    </form>
  );
}
